import React from 'react'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import Layout from '@shared/components/layout'
const PopularTeams = dynamic(() => import('@shared/components/team/popularTeams'))
const TeamsList = dynamic(() => import('@shared/components/team/teamsList'))
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })

function Teams({ seoData, popularTeams, allTeams, filteredTeams, isFiltered }) {
  return (
    <Layout data={{ oSeo: seoData }} customAmpEnable>
      <ATSAds />
      <PopularTeams popularTeams={popularTeams} />
      <TeamsList allTeams={allTeams} filteredTeams={filteredTeams} />
    </Layout>
  )
}
Teams.propTypes = {
  seoData: PropTypes.object,
  popularTeams: PropTypes.array,
  allTeams: PropTypes.array,
  filteredTeams: PropTypes.array,
  isFiltered: PropTypes.bool
}

export async function getServerSideProps({ req, res, params, query, resolvedUrl }) {
  try {
    const queryGraphql = (await import('@shared/components/queryGraphql')).default
    const { checkRedirectionStatus } = (await import('@shared-submodule/utils'))
    const GET_SEO_DATA = (await import('@graphql/article/article.query')).GET_SEO_DATA
    const { data: seo } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: 'cricket/teams' } })
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seo?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    const GET_POPULAR_TEAMS = (await import('@shared-submodule/sm-graphql/teams/teams.query')).GET_POPULAR_TEAMS
    const { data: popularTeams } = await queryGraphql(GET_POPULAR_TEAMS)
    const isFiltered = query.eSex || query.sCountryFull || query.sSearch
    if (isFiltered) {
      const TEAM_LIST_WITH_FILTERS = (await import('@shared-submodule/sm-graphql/teams/teams.query')).TEAM_LIST_WITH_FILTERS
      const { data: filteredTeams } = await queryGraphql(TEAM_LIST_WITH_FILTERS, {
        input: {
          eSex: query?.eSex || null,
          sCountryFull: query.sCountryFull || null,
          sSearch: query.sSearch || null,
          nLimit: 24,
          nSkip: 0
        }
      })
      return {
        props: {
          seoData: seo?.getSeoData,
          popularTeams: popularTeams?.listPopularTeams || [],
          filteredTeams: filteredTeams?.listTeamsWithFilters || [],
          isFiltered: true
        }
      }
    } else {
      const GET_TEAM_LIST_WITH_SERIES = (await import('@shared-submodule/sm-graphql/teams/teams.query')).GET_TEAM_LIST_WITH_SERIES
      const { data: allTeams } = await queryGraphql(GET_TEAM_LIST_WITH_SERIES)
      return {
        props: {
          seoData: seo?.getSeoData,
          popularTeams: popularTeams?.listPopularTeams || [],
          allTeams: allTeams.listTeamsByPopularSeries || []
        }
      }
    }
  } catch (e) {
    console.log({ e })
    res.setHeader('Cache-Control', 'no-cache')
    const handleApiError = (await import('@shared-submodule/utils')).handleApiError
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

export default Teams
